import { WidgetIds } from './use-dashboard-widgets';

export const libraryPriorityList = [
  'sticky-note-pink',
  'sticky-note-yellow',
  'sticky-note-purple',
  'sticky-note-green',
  'sticky-note-blue',
  'opportunity-list-widget',
  'sticky-note-orange',
  'payments-24-hours',
  'add-message',
  'bulk-texting-widget',
] as const satisfies WidgetIds[];

export const libraryPriorityIndexMap = new Map(libraryPriorityList.map((id, index) => [id, index]));
export type LibraryPriorityIndexMap = (typeof libraryPriorityList)[number];
